import TextField from '../FieldTypes/TextField';
import NumberField from '../FieldTypes/NumberField';
import PhoneNumberField from '../FieldTypes/PhoneNumberField';
import DateField from '../FieldTypes/DateField';
import DropdownField from '../FieldTypes/DropdownField';
import AttachmentField from '../FieldTypes/AttachmentField';
import CheckboxField from '../FieldTypes/CheckboxField';
import RadioButtonField from '../FieldTypes/RadioButtonField';
import EmailField from '../FieldTypes/EmailField';

const renderField = (type, index, field) => {
  switch (type) {
    case 1:
      return <TextField index={index} field={field} />;
    case 2:
      return <EmailField index={index} field={field} />;
    case 4:
      return <NumberField index={index} field={field} />;
    case 6:
      return <PhoneNumberField index={index} field={field} />;
    case 5:
      return <DateField index={index} field={field} />;
    case 9:
      return <DropdownField index={index} field={field} />;
    case 10:
      return <AttachmentField index={index} field={field} />;
    case 8:
      return <RadioButtonField index={index} field={field} />;
    case 7:
      return <CheckboxField index={index} field={field} />;
    default:
      return null;
  }
};

export default renderField;
